import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import Configurer from "../components/Configurer";
import StagesManager from "../components/StagesManager";
import { checkPermission, checkTranslation, pathMaker, translate } from "../utils/useful";
import Cookies from "universal-cookie";
import PageStatusViewer from "../components/PageStatusViewer";
import AdminDashboard from "./admin/AdminDashboard";
import AdminFormApplet from "./admin/AdminFormApplet";
import Collapsible from "react-collapsible";
import Modal from "../components/Modal";
import AdminPermission from "./admin/AdminPermission";
import EnergyWidgetsPage from "./admin/EnergyWidgetsPage";
import { settingsPages } from "../variables/settingsPages";
import AdminSettingsApplet from "./admin/AdminSettingsApplet";
import AdminChangeBranchApplet from "./admin/AdminChangeBranchApplet";


class Settings extends React.Component {

    state = {
        modules: [],
        collapses: {},
        pages: [
            { name: 'Dashboard', key: '', dontShowInDashboard: true },
            { name: 'Edit Profile', icon: 'https://www.flaticon.com/svg/static/icons/svg/2444/2444452.svg', key: 'edit' },
            { name: 'Account type', icon: 'https://www.flaticon.com/svg/static/icons/svg/744/744922.svg', key: 'type' },
            { name: 'Change Password', icon: 'https://www.flaticon.com/svg/static/icons/svg/3039/3039392.svg', key: 'password' },
        ]
    }


    componentDidMount() {
        let accessPages = Object.values(settingsPages)

        this.setState({ isLoading: false }, () => {
            this.checkDefaultTab()
            this.setState({ modules: accessPages })
        })

        let sections = accessPages

        this.props.setHeader({ title: '{{lang}}Settings', baseUrl: JSON.parse(JSON.stringify(this.props.baseUrl)), sections, permissionBaseKey: 'settings', applet: { _id: 'admin' } })


        // return

        // const cookies = new Cookies();
        // let token = cookies.get('admintoken');
        // if (token) {
        //     this.setState({ isLoading: true })
        //     this.waitForId(10)
        // } else {
        //     this.setState({ pageStatus: 401 })
        // }

        // setInterval(() => {
        //     // console.log("HERE")
        //     if(this.configurer){
        //         console.log(this.configurer)
        //         console.log(this.configurer.props.settingsInfo)
        //     }
        // }, 2000);

        // if(this.configurer){
        //     console.log(this.configurer)
        //     console.log(this.configurer.settingsInfo)
        // }
    }


    // waitForId = (leftAttempt) => {
    //     if (this.props.user?.info?._id) {

    //         this.setState({ isLoading: false }, () => {
    //             this.checkDefaultTab()
    //             let accessPages = Object.values(settingsPages)
    //             this.setState({ modules: accessPages })
    //         })
    //     } else {
    //         setTimeout(() => {
    //             if (leftAttempt != 0) {
    //                 this.waitForId(leftAttempt - 1)
    //             } else {
    //                 // this.props.actions.logoutUser()
    //                 this.setState({ pageStatus: 401 })
    //             }
    //         }, 500);
    //     }
    // }


    componentDidUpdate(prevProps) {
        // let windowPath = this.props.location.pathname.split('/')
        // windowPath = windowPath[windowPath.length - 1]

        // // console.log(this.state.oldPath)
        // // console.log(this.props.location.pathname)
        // if (this.state.oldPath != this.props.location.pathname) {
        //     this.setState({ oldPath: this.props.location.pathname }, () => {
        //         this.checkDefaultTab()
        //     })
        // }

        if (prevProps.windowData?.path != this.props.windowData?.path) {
            // this.setState({ oldPath: this.props.location.pathname }, () => {
            this.checkDefaultTab()
            // })
        }

    }



    checkDefaultTab() {

        let def = ''
        let pageType = null
        let pageInfo = null
        let pathname = window.location.pathname.split('/')
        pathname.forEach((path, index) => {
            if (path == 'settings') {
                def = pathname[index + 1]
            }
        });

        // console.log(def)

        let pageIsValid = false

        Object.values(settingsPages).forEach(page => {
            if (page.key.toLowerCase() === def?.toLowerCase()) {
                pageIsValid = true
                pageType = page.pageType
                // console.log(page)
                pageInfo = page
            }
        });

        // console.log("pageInfo")
        // console.log(checkPermission(pageInfo.permissionRules))
        // if (!def || def == '' || checkPermission('energy.' + pageInfo.key) || (pageInfo.permissionRules && checkPermission(pageInfo.permissionRules))) {
        if (true) {

            if (!def) {
                def = ''
            }
            // console.log(def)
            if (def === '') {
                pageType = ''
                pageIsValid = true
            }
            if (pageIsValid) {
                // this.state.page = page
                // console.log(page)
                this.setState({ oldPath: this.props.location.pathname, pageStatus: 200 }, () => {
                    this.setState({ path: def, }, () => {
                        this.stageManager.changeStage(pageType, () => {
                            window.scrollTo({ top: 0, behavior: 'smooth' })
                        })
                        setTimeout(() => {
                            this.setState({ page: null }, () => {

                                this.setState({ page: pageInfo })
                            })
                        }, 400);
                    })

                    // this.changePage(def)
                    // if (def == '' || !def) {
                    // this.stageManager.changeStage('dashboard')
                    // this.stageManager.changeStage(def)
                    // // this.props.history.push(pathMaker('/profile'))
                    // } else {

                    //     this.stageManager.changeStage(def)

                    // }
                })
            } else {
                this.setState({ pageStatus: 404 })
            }
        } else {
            this.setState({ pageStatus: 401 })
        }

    }



    changePage = (page) => {


        let path = [...this.props.baseUrl, page]

        path = pathMaker(path.join('/'))

        // console.log(path)

        this.props.history.push(path)

        if (this.mobileMenuModal) {
            this.mobileMenuModal.hideModal()
        }

    }


    setUser = (data) => {
        this.props.actions.setUser(data, null, true)
    }


    addNotif = (options) => {
        this.props.actions.addNotif(options)
    }

    changeCollapse = (key) => {
        let collapses = this.state.collapses
        collapses[key] = this.state.collapses[key] == null ? true : !this.state.collapses[key]
        this.setState({ collapses })
    }


    showMenu() {
        return (
            <div>
                <div className="text-center py-3">
                    <img src="/images/male.png" width="70px" style={{ borderRadius: 100 }} />
                    <p className="font-bold mt-1">{this.props.user?.info?.name} {this.props.user?.info?.family}</p>
                    <p className="text-small">{translate("تنظیمات")}</p>
                </div>

                <div className="mt-2">
                    <button onClick={() => this.changePage('')} className={"pageSideOption mainPage " + ('' == this.state.path ? "selected" : '')}>
                        <p>{translate('تنظیمات پلتفرم')}</p>
                    </button>

                    {Object.values(settingsPages).map((prop, index) => {
                        return (
                            <div className="mt-0 pb-0" style={{ borderBottom: '1px solid #F87C5620' }}>
                                <button className="flexcb w-100 py-2 m-0 px-0" style={{ backgroundColor: !this.state.collapses[prop.key] ? '#F87C5610' : '#F87C5620' }} onClick={() => this.changeCollapse(prop.key)}>
                                    <p className="text-smaller text-bold text-uppercase" style={{ whiteSpace: 'nowrap', color: '#567', padding: '0px 12px' }}>{prop.name}</p>
                                    <p className="text-normal text-bold px-2" style={{ color: '#F87C5670' }}>{!this.state.collapses[prop.key] ? "-" : "+"}</p>
                                </button>

                                <Collapsible open={!this.state.collapses[prop.key]}>
                                    {this.state.modules.map((cprop, index) => {
                                        if (cprop.parent == prop.key) {
                                            if (checkPermission("settings" + '.' + cprop.key)) {
                                                return (
                                                    <button onClick={() => this.changePage(cprop.key)} key={index} className={"flexc pageSideOption " + (cprop.key == this.state.path ? "selected" : '')} style={{ padding: '8px 20px' }}>
                                                        <img className="mrd-3" src={cprop.image} style={{ borderRadius: 30, width: 30, height: 30, objectFit: 'cover' }} />
                                                        <p className="text-small " >{checkTranslation(cprop.title)}</p>
                                                    </button>
                                                )
                                            }
                                        }
                                    })
                                    }
                                </Collapsible>
                            </div>
                        )
                    })}
                </div>
                <div className="m-2" style={{}}>
                    {this.state.modules.map((cprop, index) => {
                        // console.log('ridix cProp', cprop)
                        if (cprop.parent == 'whthoutParent' && !cprop.hidePage) {
                            if (checkPermission("settings" + '.' + cprop.key) || cprop.key == 'messages') {
                                return (
                                    <div className="mx-2">
                                        <button onClick={() => this.changePage(cprop.key)} key={index} className={"flexc pageSideOption " + ((cprop.key == this.state.path) ? "selected brl" : 'opacity-8')} style={{ padding: '12px 20px' }}>
                                            {/* <img className="mrd-3" src={cprop.image} style={{ width: 20, height: 20, }} /> */}
                                            <p className=" " style={{ fontSize: "12px", fontWeight: "400" }} >{checkTranslation(cprop.title)}</p>
                                        </button>
                                    </div>
                                )
                            }
                        }
                    })}
                </div>
            </div>
        )
    }

    navigationBackButton(action) {
        return (
            <div className="flexc mx-2 h-100 d-md-none">
                <button className="p-0 m-0 flexcc h-100" onClick={() => this.mobileMenuModal.showModal()} style={{ backgroundColor: '#f2f6f8dd', color: '#334455', fontWeight: 'bold' }}>
                    <img className=" " src="/images/menu.png" alt="" width="30px" />
                </button>
                {/* <button onClick={() => this.props.nextStage()} style={{ backgroundColor: '#202020', color: '#fff', borderRadius: 30, padding: '5px 15px', fontWeight: 'bold' }}>NEXT</button> */}
            </div>
        )
    }

    informParent = (message) => {
        if (message == 'permissionDenied') {
            this.setState({ pageStatus: 401 })
        }
        if (message == 'notFound') {
            this.setState({ pageStatus: 404 })
        }
    }

    render() {

        let variables = {
            permissionRoot: 'settings.' + (this.state.page?.permissionParent ?? this.state.page?.key)
        }
        return (

            <Configurer
                settingsInfo={{
                    showFooter: true, showTabBar: true, showHeader: true, headerTitle: "Admin", button: {},
                    titleButtons: [this.navigationBackButton(this.props.lastStage)]

                }}
                title={"Admin"}
                description={"Admin Description"}
                className="p-0 min-full-height w-100"
                ref={el => this.configurer = el}
            >

                <PageStatusViewer status={this.state.pageStatus}>
                    <div className="w-100" >
                        <div className="row m-0">

                            {/* <div className="col-12 col-sm-12 col-md-3 col-lg-2 pageSide px-0 d-md-block d-none" >
                                {this.showMenu()}
                            </div> */}


                            <Modal ref={el => this.mobileMenuModal = el} maxWidth={300}>
                                <div className="pageSide" style={{ backgroundColor: '#fff', borderRadius: 15, padding: '20px 5px 70px 5px' }}>
                                    {this.showMenu()}

                                </div>
                            </Modal>



                            {/* {console.log('this.props.user', this.props.user)} */}
                            <div className="col-12" style={{}}>
                                <StagesManager ref={el => this.stageManager = el} >
                                    {/* <EnergyWidgetsPage pages={this.state.pages}  baseUrl={[...this.props.baseUrl]} stage={0} user={this.props.user} modules={this.state.modules} stageName={''} changePage={this.changePage} title={"داشبورد"} description={`کاربر گرامی ${this.props.user.info.name} خوش آمدید`} route={"settings"} /> */}

                                    <AdminDashboard pages={this.state.pages} permissionBaseKey={'settings'} windowData={this.props.windowData} baseUrl={[...this.props.baseUrl]} stage={0} user={this.props.user} modules={this.state.modules} stageName={''} changePage={this.changePage} title={"تنظیمات پلتفرم"} description={"لیست تنظیمات سیستمی"} route={"settings"} />
                                    <AdminSettingsApplet pages={this.state.pages} permissionBaseKey={'settings'} windowData={this.props.windowData} baseUrl={[...this.props.baseUrl]} stage={1} user={this.props.user} modules={this.state.modules} changePage={this.changePage} title={"Settings"} description={"لیست تنظیمات سیستمی"} stageName={'settings'} route={"settings"} />
                                    <AdminFormApplet pages={settingsPages} applet={{ _id: 'admin' }} permissionBaseKey={'settings'} page={this.state.page} stage={1} baseUrl={[...this.props.baseUrl]} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} informParent={this.informParent} history={this.props.history} variables={variables} stageName={'form'} route={"settings"} />
                                    <AdminChangeBranchApplet pages={this.state.pages} applet={{ _id: 'admin' }} permissionBaseKey={'settings'} page={this.state.page} stage={1} baseUrl={[...this.props.baseUrl]} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} informParent={this.informParent} history={this.props.history} variables={variables} stageName={'changeBranch'} route={"settings"} />
                                    <AdminPermission pages={this.state.pages} applet={{ _id: 'admin' }} permissionBaseKey={'settings'} validSections={['settings']} windowData={this.props.windowData} baseUrl={[...this.props.baseUrl]} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} informParent={this.informParent} history={this.props.history} variables={variables} stageName={'permissions'} route={"settings"} />

                                </StagesManager>


                            </div>
                        </div>
                    </div>
                </PageStatusViewer>

            </Configurer>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Settings);
